import { Card, CardContent } from '@/components/ui/card';
import { BarChart3, TrendingUp, Receipt, FileCheck } from 'lucide-react';

export default function StandardReportsTab({ setActiveTab }) {
  return (
    <div data-testid="standard-reports-tab">
      <h1 className="text-3xl font-bold text-slate-900 mb-6">Standard Reports</h1>
      <div className="grid grid-cols-2 gap-6">
        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => setActiveTab('reports')}>
          <CardContent className="pt-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-blue-100 rounded-lg"><BarChart3 className="w-6 h-6 text-blue-600" /></div>
              <div>
                <p className="font-semibold">Team & Vendor Reports</p>
                <p className="text-sm text-slate-500">Performance metrics for teams and vendors</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => setActiveTab('analytics')}>
          <CardContent className="pt-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-green-100 rounded-lg"><TrendingUp className="w-6 h-6 text-green-600" /></div>
              <div>
                <p className="font-semibold">Analytics Report</p>
                <p className="text-sm text-slate-500">Detailed analytics and trends</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => setActiveTab('client-invoices')}>
          <CardContent className="pt-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-purple-100 rounded-lg"><Receipt className="w-6 h-6 text-purple-600" /></div>
              <div>
                <p className="font-semibold">Invoice Reports</p>
                <p className="text-sm text-slate-500">Client billing and payment tracking</p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card className="hover:shadow-lg transition-shadow cursor-pointer" onClick={() => setActiveTab('cases')}>
          <CardContent className="pt-6">
            <div className="flex items-center gap-4">
              <div className="p-3 bg-amber-100 rounded-lg"><FileCheck className="w-6 h-6 text-amber-600" /></div>
              <div>
                <p className="font-semibold">Case Status Report</p>
                <p className="text-sm text-slate-500">Overview of all verification cases</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
